import type { IInitialFormValues, TFormType } from '../types';

const handleSuccess = (values: IInitialFormValues, form: TFormType) => {
  window?.heap?.track?.('Marketing Form Success', {
    emailAddress: values?.email ?? '',
    formName: form,
    host: process.env.GATSBY_HOST ?? '',
  });
};

export default handleSuccess;
